import type { HTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

export type CardProps = HTMLAttributes<HTMLDivElement>;

/**
 * Basic surface card used across the admin (metrics, tables, sections).
 * Matches the Figma rounded white panels.
 */
export function Card({ className, ...props }: CardProps) {
  return (
    <div
      className={cn('bg-white rounded-[16px] border border-[#e5e5e5] shadow-sm', className)}
      {...props}
    />
  );
}
